import Vue from 'vue' 

export function hasPermission( actionName ) {
  if ( actionName == "home" ) {
    return true;
  }
  const token = Vue.prototype.$jwt.decode();
  if ( token ) {
      for( const permission of token.data.permissions ){
        if ( typeof actionName === 'string' ? permission === actionName : actionName.includes( permission ) ){
          return true;
        }
    }
  }
  return false;
}